import { SvgIconArrowDown } from '../svg/icon-arrow-down';
import { SvgGuideNavIconCart } from '../svg/img-guide-nav-icon-cart';
import { SvgGuideNavIconDevice } from '../svg/img-guide-nav-icon-device';

export const SiteGuideAnchorNav = () => {
  return (
    <>
      <nav className="flex justify-center gap-16 py-18">
        <a href="#service" className="max-w-[135px]">
          <SvgGuideNavIconDevice className="mx-auto mb-2 w-[72px]" aria-label="サイトを通るだけで株がもらえる" />
          <p className="text-body-s-bold text-center">
            サイトを通るだけ
            <br />
            で株がもらえる
          </p>
          <SvgIconArrowDown className="text-brand mx-auto mt-4 size-4 flex-none" aria-label="下向き矢印" />
        </a>
        <a href="#contents" className="max-w-[135px]">
          <SvgGuideNavIconCart className="mx-auto mb-2 w-[72px]" aria-label="幅広いコンテンツ" />
          <p className="text-body-s-bold text-center">
            幅広い
            <br />
            コンテンツ
          </p>
          <SvgIconArrowDown className="text-brand mx-auto mt-4 size-4 flex-none" aria-label="下向き矢印" />
        </a>
      </nav>
    </>
  );
};
